import { ILoginData } from "./login.types";

export class LoginData implements ILoginData {
  readonly accessToken: string;
  readonly refreshToken: string;
  readonly memberUid: string;
  readonly isTempPassword?: boolean;
  readonly isPasswordExpired?: boolean;
  // isAutoLogin: boolean;

  constructor(data: ILoginData) {
    this.accessToken = data.accessToken;
    this.refreshToken = data.refreshToken;
    this.memberUid = data.memberUid;
    this.isTempPassword = data.isTempPassword;
    this.isPasswordExpired = data.isPasswordExpired;
    // this.isAutoLogin = data.isAutoLogin;
  }
}
